import {
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import styles from "styles/component/CourseMapOptionListTable.module.scss";
import styles1 from "styles/component/PopOver.module.scss";
import popoverStyles from "styles/component/CustomCoursePopOver.module.scss";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import {
  FacilityHazardElements,
  HoleElements,
  courseMapZoneTypeList,
} from "json/constants";
import {
  convertToLabelName,
  decryptSecretKey,
  getModalProperties,
} from "services/utils";
import asset from "json/assets";
import * as _ from "underscore";
import { useDispatch } from "react-redux";
import {
  clearCourseCliffDesc,
  clearCourseForestType,
  clearCourseNativeAreaDesc,
  clearCourseNativeAreaSize,
  clearCourseNativeAreaType,
  clearCourseShapePropertiesDesc,
  clearCourseShapePropertiesSize,
  clearCourseShapePropertiesType,
  clearEditableCourseItem,
  course_gps_vector_map_remove,
  course_map_gps_vector_details,
  setCourseCliffDesc,
  setCourseForestType,
  setCourseNativeAreaDesc,
  setCourseNativeAreaSize,
  setCourseNativeAreaType,
  setEditableCourseItem,
  setSelectedCourseZoneType,
  setVisibleFacilityElements,
  updateCourseMapData,
} from "redux/CourseMapSlice";
import {
  useCourseMapData,
  useEditableCourseItem,
  useIsDrawingStatus,
  useVisibleFacilityElements,
} from "hooks/CourseMapDetails";
import useNotiStack from "hooks/useNotistack";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import { useRefHook } from "hooks/useRefHook";
import { useSearchParams } from "react-router-dom";
import { useProfileUsername } from "hooks/ProfileDetails";
import { BULK_DELETE_API_SUPPORTED, isFacilityVectorElement, normalizeElementForApi } from "./FacilityHazardFeatures.helper";

function FacilityHazardFeatures({ courseWiseData, element, setElement }) {
  let singleType = true;

  const dispatch = useDispatch();
  const ScrollableClient = useRef();
  const { toastError,toastSuccess } = useNotiStack();
  const secret_Key = decryptSecretKey();
  const username = useProfileUsername();
  const editableArea = useEditableCourseItem();
  const isDrawingStatus = useIsDrawingStatus();
  const modalProperties = getModalProperties();
  const courseMapData = useCourseMapData();
  const editableAreaRef = useRefHook(editableArea);
  const [searchParams] = useSearchParams();
  const id_courseFromQuery = searchParams.get("course");
  const [openDelAllConfModal, setOpenDelAllConfModal] = useState(false);
  const [showableData, setShowableData] = useState([]);
  const visibleFacilityElementList = useVisibleFacilityElements();
  const [openConfModal, setOpenConfModal] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [propertiesChange, setPropertiesChange] = useState()

  const handleChangeMarkerType = useCallback((event) => {
    eventEmitter.emit(events.resetDrawingMode);
    setElement(event.target.value);
     dispatch(clearCourseCliffDesc())
      dispatch(clearCourseForestType())
      dispatch(clearCourseNativeAreaDesc())
      dispatch(clearCourseNativeAreaType())
      dispatch(clearCourseNativeAreaSize())
  }, []);
  const handleClose = () => {
    setOpenConfModal(false);
  };

  const handleAllDelClose = () => {
    setOpenDelAllConfModal(false);
  };
  const fillData = () => {
    setShowableData([]);

    if(element && _.isEmpty(courseWiseData)){
      let _redxObj = {
        hole: -1,
        type: courseMapZoneTypeList[`${element.toLowerCase()}`],
        element: element,
        // data:showableData?.length?showableData:(showableFCBData?.length? showableFCBData:[])
        data: [],
      };
      dispatch(setSelectedCourseZoneType(_redxObj));
    }

    if (element && !_.isEmpty(courseWiseData)) {
      if (element === "Tree") {
        //removing tree list for loading issue
        let _redxObj = {
          hole: -1,
          type: courseMapZoneTypeList[`${element.toLowerCase()}`],
          element: element,
        };
        dispatch(setSelectedCourseZoneType(_redxObj));
        return;
      }

      let data = courseWiseData.filter((s) => s.label === element);

      setShowableData(data);
      let _redxObj = {
        hole: -1,
        type: courseMapZoneTypeList[`${element.toLowerCase()}`],
        element: element,
        data: data,
      };
      dispatch(setSelectedCourseZoneType(_redxObj));
    }
  };
  // click func select and edit on
  const clearEditableModeVariables = () => {
    dispatch(clearEditableCourseItem());
    dispatch(clearCourseShapePropertiesType());
    dispatch(clearCourseShapePropertiesSize());
    dispatch(clearCourseShapePropertiesDesc());
  };
  const isShapeHoleItem = (shape) => {
    return shape && shape.zone
      ? HoleElements.some((s) => s.toLowerCase() === shape?.zone.toLowerCase())
      : false;
  };

  const removeFacilityVectorsBulk = async (elementNameForApi) => {
    await dispatch(
      course_gps_vector_map_remove({
        body: {
          id_courseInt: Number(id_courseFromQuery),
          name: elementNameForApi, // course-wide facility/hazard delete (no holeNumber)
        },
        user: { secretKey: secret_Key, userName: username },
      })
    );

    // refresh facility/hazard vectors in state
    await dispatch(
      course_map_gps_vector_details({
        body: { id_course: id_courseFromQuery },
        user: { secretKey: secret_Key, userName: username },
      })
    );
  };

  


  const toggleEditMode = (shape) => {
    if (isDrawingStatus) return;
  
    if (editableAreaRef.current && editableAreaRef.current._id !== shape._id) {
      editableAreaRef.current = null; 
  }
    if (shape?.hole === -1) {
      if (_.isEmpty(editableAreaRef.current)) {
            setPropertiesChange(shape)
        dispatch(setEditableCourseItem(shape));
        editableAreaRef.current = shape;
      }
      return;
    }

    if (_.isEmpty(editableAreaRef.current)) {
      let isHoleItem = isShapeHoleItem(shape);

      if (isHoleItem) {
        switch (shape?.zone) {
          case "Greencenter":
            if (editableArea?.greenID === shape?.greenID) {
              clearEditableModeVariables();
            } else {
              dispatch(setEditableCourseItem(shape));
            }
            break;
          default:
            if (editableArea?._id === shape?._id) {
              // dispatch(clearEditableCourseItem());
              clearEditableModeVariables();
            } else {
              dispatch(setEditableCourseItem(shape));
            }
            break;
        }
      } else {
        dispatch(setEditableCourseItem(shape));
      }
    }

  };
  const hasData = (element) => {
    
    if (element === "Tree") {
      let hasData = !courseWiseData.some((s) => s.label === element);
      return hasData;
    } else {
      return _.isEmpty(showableData);
    }
  };
  useEffect(() => {
    fillData();
  }, [element, courseWiseData]);
  // let maxModFieldCount=2

  const hasElementData = (marker) => {
    let data = courseWiseData.filter((s) => s.label === marker.value);
    return !_.isEmpty(data);
  };

  const toggleItemView = (data) => {
    if (checkIfActionable()) {
      let temp_visibleFacilityElementList = JSON.parse(
        JSON.stringify(visibleFacilityElementList)
      );

      let testSet = new Set(
        temp_visibleFacilityElementList[`${data?.label}`].idList
      );

      if (testSet.has(data?._id)) {
        testSet.delete(data._id);
      } else {
        testSet.add(data._id);
      }
      const newArray = [...testSet];
      temp_visibleFacilityElementList[`${data?.label}`].idList = newArray;

      dispatch(setVisibleFacilityElements(temp_visibleFacilityElementList));
    }
  };

  const toggleAllItemView = () => {
    if (checkIfActionable()) {
      let temp_visibleFacilityElementList = JSON.parse(
        JSON.stringify(visibleFacilityElementList)
      );
// if (temp_visibleFacilityElementList[`${element}`]) {
//   temp_visibleFacilityElementList[`${element}`].isGroupVisible =
//     !temp_visibleFacilityElementList[`${element}`].isGroupVisible;
// }
if(element === "NativeArea"){
  if (temp_visibleFacilityElementList[`Nativearea`]) {
    temp_visibleFacilityElementList[`Nativearea`].isGroupVisible =
      !temp_visibleFacilityElementList[`Nativearea`].isGroupVisible;
  }
}else{
  if (temp_visibleFacilityElementList[`${element}`]) {
    temp_visibleFacilityElementList[`${element}`].isGroupVisible =
      !temp_visibleFacilityElementList[`${element}`].isGroupVisible;
  }
}
      // if (temp_visibleFacilityElementList[`${element}`]) {
      //   temp_visibleFacilityElementList[`${element}`].isGroupVisible =
      //     !temp_visibleFacilityElementList[`${element}`].isGroupVisible;
      // }

      dispatch(setVisibleFacilityElements(temp_visibleFacilityElementList));
    }
  };

  const getActiveFacilityFeatureIcon = (data) => {
    
    if (visibleFacilityElementList[`${data?.label}`]?.isGroupVisible) {
      let _t = new Set(visibleFacilityElementList[`${data?.label}`].idList);
      return _t.has(data?._id);
    }
    // else if(data?.label === "NativeArea" && visibleFacilityElementList[`Nativearea`]?.isGroupVisible){
    //   let _t = new Set(visibleFacilityElementList[`Nativearea`].idList);
    //   return _t.has(data?._id);
    // }
     else {
      return false;
    }
  };
  const isAllMemberVisible = () => {
    if(element === "NativeArea"){
 return visibleFacilityElementList[`Nativearea`]?.isGroupVisible
    }else{
      return visibleFacilityElementList[`${element}`]?.isGroupVisible;

    }
  };
  const checkIfActionable = () => {
    if(element === "Tree" && isDrawingStatus){
      return true
    }
    if (isDrawingStatus || !_.isEmpty(editableArea)) {
      return false;
    } else return true;
  };

  const getDeleteConfirmation = (data) => {
    setOpenConfModal(true);
  };

  const getDeleteAllConfirmation = (data) => {
    if (checkIfActionable()) {
      setOpenDelAllConfModal(true);
    } else {
      toastError("can not delete elements while draw/edit is active");
    }
  };

  const clearAllElements = async () => {
    const apiElement = normalizeElementForApi(element);

    if (!isFacilityVectorElement(apiElement)) {
      return;
    }

    try {
      if (BULK_DELETE_API_SUPPORTED.has(apiElement)) {
        await removeFacilityVectorsBulk(apiElement);
      } else {
        // Backend doesn't support bulk delete for this element name.
        // Fall back to individual deletion (same mechanism as single delete).
        const idList = showableData.map(d => d._id).filter(Boolean);
        if (idList.length) {
          eventEmitter.emit(events.deleteCourseMapElement.courseMapVectorDelete, {
            idList,
            type: "facility",
          });
        }
      }

      // Local cleanup to keep UI in sync
      const temp_courseMapData = structuredClone(courseMapData);
      if (temp_courseMapData?.[apiElement]) {
        delete temp_courseMapData[apiElement];
        dispatch(updateCourseMapData(temp_courseMapData));
      }
    } catch (e) {
      toastError(`Failed to delete all ${apiElement}. Please try again.`);
    }
  };

  const confirmationDelAllAction = () => {
    handleAllDelClose();
    clearAllElements();
  };

  const deleteSingleElement = (data) => {
    if (checkIfActionable()) {
      setSelectedShape(data);
      getDeleteConfirmation();
    } else {
      toastError("can not delete elements while draw/edit is active");
    }
  };
 const singleElement = ["Water" , "Vegetation" , "Sand" , "Lava" , "Fixtures"]
  const confirmationAction = () => {
    // eventEmitter.emit('ss',{id:selectedShape.id,selectedHole:parseInt(selectedHole),element:element})
    // handleClose();
    if (selectedShape) {
      let temp_courseMapData = structuredClone(courseMapData);
      const modifiedElement = element === "Nativearea" ? "NativeArea" : element
      temp_courseMapData[`${modifiedElement}`].ShapeCount -= 1;
      let pos = temp_courseMapData[modifiedElement].Shapes.Shape.findIndex(
        (s) => s.id === selectedShape._id
      );

      eventEmitter.emit(events.deleteCourseMapElement.courseMapVectorDelete, {
        idList: [selectedShape._id],
        type: "facility",
      });
      temp_courseMapData[modifiedElement].Shapes.Shape.splice(pos, 1);

      dispatch(updateCourseMapData(temp_courseMapData));

      handleClose();
    }
  };
  return (
    <>
      <div
        className={`${
          !singleType
            ? `${styles.table_select}`
            : `${styles.table_select}${styles.table_blank}`
        }`}
      >
        <Box className={popoverStyles.poover_content}>
          <Box
            className={`${popoverStyles.popover_body_new} ${popoverStyles.popover_body_courseMapList}`}
          >
            <FormControl>
              <RadioGroup
                className={styles.marker_option}
                aria-labelledby="demo-radio-buttons-group-label"
                // defaultValue="FLAG"
                name="radio-buttons-group"
                // value={"Hole 1"}
                value={element}
                onChange={(e) => {
                  // if (checkIfActionable()) {
                  handleChangeMarkerType(e);
                  // }
                }}
              >
                {FacilityHazardElements?.map((marker, index) => (
                  <>
                    <FormControlLabel
                      className={
                        hasElementData(marker)
                          ? `${popoverStyles.green_border}`
                          : ""
                      }
                      // className={popoverStyles.green_border} // for green  outline
                      value={marker.value}
                      control={<Radio checked={marker.value === element} />}
                      // control={<Radio checked={marker.value === "teeboxes"} />}
                      label={marker.label}
                      key={index}
                    />
                  </>
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>

        <div
          className={styles.table_btm}
          ref={ScrollableClient}
          id="listContainer"
        >
 
          {/* <table className={isTableStylesTwo  ?`${styles.table_two}`:""}> */}
          {
            // !showableData.length
            hasData(element) ? (
              <div className={styles1.list_icon_para}>
                <p className={styles.no_marker_text}>
                  {singleElement?.includes(element) ?  `No ${element} Mapped` :
                    element === "Nativearea" ? "No Native Areas Mapped":
                     `No ${element}s Mapped`}
                </p>
              </div>
            ) : (
              <table className={""} id={"list_table"}>
                <thead>
                  <tr>
                    <th>
                      {singleElement?.includes(element) ?  `All ${convertToLabelName(element)}` : `All ${convertToLabelName(element === "Nativearea" ? "Native Area" : element)}s`}
                    </th>
                    <th>
                      <Box className={styles.color_mod_box}>
                        <Button
                          className={`${
                            isAllMemberVisible(element)
                              ? styles.green
                              : styles.grey
                          }`}
                          // disabled={editableArea}
                          onClick={toggleAllItemView}
                        >
                          <img src={asset.eye} alt="" className="eye_size" />
                        </Button>
                      </Box>
                    </th>
                    <th>
                      <Box className={styles.color_mod_box}>
                        <Button
                          // disabled={editableArea}
                          className={`${styles.green}`}
                          onClick={getDeleteAllConfirmation}
                        >
                          <img src={asset?.close} alt="" />
                        </Button>
                      </Box>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* Something will come here... eventually (._.') */}
                  {
                    // selectedZoneDetails.length > 0 &&
                    showableData?.map((data, index) => {
                      return (
                        <tr key={index} id={data?.label}>
                          <td
                            style={
                              {
                                // cursor: "pointer",
                                // outline:
                                //   editableArea === data?.label
                                //     ? "1px dashed #133E84"
                                //     : "",
                              }
                            }

                            onClick={()=>{
                              eventEmitter.emit(events.zoomMapToCoordinate,{ coordinate: [ data?.list[0]?.[0][0], data?.list[0]?.[0][1]] });
                              toggleEditMode(data)
                              dispatch(setEditableCourseItem(data));
                              if(data?.label === "Cliff"){
                                dispatch(setCourseCliffDesc(data?.Attributes?.Description))
                              }else if(data?.label === "Forest" ){
                                 dispatch(setCourseForestType(data?.Attributes?.Type)) 

                              }else if(data?.label === "Nativearea"){
                                dispatch(setCourseNativeAreaDesc(data?.Attributes?.Description))
                                          dispatch(setCourseNativeAreaType(data?.Attributes?.Type))
                                          dispatch(setCourseNativeAreaSize(data?.Attributes?.Size))
                              }
                                     
                                      }}

                            // className={noProp===true?`${styles.defaultzone_save_btn}` :""}
                          >
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                            >
                              {data?.label[0]}
                              {index + 1}
                            </Stack>
                          </td>
                          <td>
                            <Box className={styles.color_mod_box}>
                              <Button
                                id={index}
                                className={
                                  getActiveFacilityFeatureIcon(data)
                                    ? // && !editableArea
                                      `${styles.green}`
                                    : `${styles.grey}`
                                }
                                // disabled={editableArea}
                                // onClick={() => {}}
                                onClick={() => {
                                  toggleItemView(data);
                                }}
                              >
                                <img src={asset?.eye} alt=""   className="eye_size"/>
                              </Button>
                            </Box>
                          </td>
                          <td>
                            <Box className={styles.color_mod_box}>
                              <Button
                                //  disabled={editableArea}
                                onClick={() => {
                                  deleteSingleElement(data);
                                }}
                              >
                                <img src={asset?.close} alt="" />
                              </Button>
                            </Box>
                          </td>
                        </tr>
                      );
                    })
                  }

                  {/* </InfiniteScroll> */}
                  {/* </>
                )} */}

                  {/* )} */}
                </tbody>
              </table>
            )
          }
        </div>
      </div>
      <ModalWrapper
        open={openConfModal}
        onClose={handleClose}
        handleClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.warning.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete 
               <br/>${element}?
               </span>`}
          // content="Any unsaved data will be discarded."
          rejCallBack={handleClose}
          affrCallBack={confirmationAction}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>

      <ModalWrapper
        open={openDelAllConfModal}
        onClose={handleAllDelClose}
        handleClose={handleAllDelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.error.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete 
          <br/>all ${singleElement?.includes(element) ? element : `${element === "Nativearea" ? "Native Area" : element}s`}?</span>`}
          // title={`<span style='font-size:14px'>Are you sure you want to delete
          //      <br/>all data from ${convertToLabelName((selectedHole))}?</span>`}
          // content="Any unsaved data will be discarded."
          rejCallBack={handleAllDelClose}
          affrCallBack={confirmationDelAllAction}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>
    </>
  );
}

export default memo(FacilityHazardFeatures);
